import { isUuid } from './uuid';

/**
 * Strip the JSON quoting Segment wraps its ids in.
 *
 * The Worker writes these cookies bare while Segment's SDK writes `"<uuid>"`,
 * so the same id arrives in two shapes and has to resolve to one. Percent
 * decoding is already done by `parseCookie`.
 */
const normalizeCookieValue = (raw: string): string => {
  const value = raw.trim();
  return value.length >= 2 && value.startsWith('"') && value.endsWith('"')
    ? value.slice(1, -1).trim()
    : value;
};

/**
 * A cookie value that is present, normalized, and a UUID; otherwise null.
 *
 * Exported because a caller reading a cookie this module does not model still
 * has to resolve it the same way — the Worker validates Segment's own id this
 * way before deciding whether to keep it.
 */
export const readUuid = (raw: string | undefined): string | null => {
  if (raw === undefined) {
    return null;
  }
  const value = normalizeCookieValue(raw);
  return isUuid(value) ? value : null;
};

/** A cookie value that is present and non-empty, whatever its shape. */
export const readValue = (raw: string | undefined): string | null => {
  if (raw === undefined) {
    return null;
  }
  const value = normalizeCookieValue(raw);
  return value === '' ? null : value;
};
